import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { PracticeSetupStepCategory } from '@principle-theorem/principle-core/interfaces';
import { SetupWizardStepComponent } from '../setup-wizard-step/setup-wizard-step.component';
import { IWizardCategorySection } from '../setup-wizard.store';

@Component({
  selector: 'pr-setup-wizard-steps',
  templateUrl: './setup-wizard-steps.component.html',
  styleUrls: ['./setup-wizard-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgCommonModule,
    MatExpansionModule,
    MatIconModule,
    SetupWizardStepComponent,
  ],
})
export class SetupWizardStepsComponent {
  readonly categories = input.required<IWizardCategorySection[]>();
  readonly expandedCategories = input<Set<PracticeSetupStepCategory>>(
    new Set()
  );
  readonly showCategoryStatusStyles = input(false);
  readonly showCompletionIcon = input(false);

  readonly panelOpened = output<PracticeSetupStepCategory>();
  readonly panelClosed = output<PracticeSetupStepCategory>();

  readonly allSteps = computed(() =>
    this.categories().flatMap((section) => section.steps)
  );

  categoryTrackBy(
    _index: number,
    section: IWizardCategorySection
  ): PracticeSetupStepCategory {
    return section.category;
  }

  isSectionComplete(section: IWizardCategorySection): boolean {
    return section.total > 0 && section.completed === section.total;
  }

  isSectionInProgress(section: IWizardCategorySection): boolean {
    return section.completed > 0 && section.completed < section.total;
  }
}
